import React from 'react';
import { Spin } from 'antd';
import { CancelAccountProps } from './CancelAccount';

const LazyCancelAccount = React.lazy(() => import('./CancelAccount'));
export const AsyncCancelAccount: React.FC<CancelAccountProps> = props => (
	<React.Suspense fallback={<Spin />}>
		<LazyCancelAccount {...props} />
	</React.Suspense>
);
